
































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  MelosDevice,
  MelosContentOrder,
  MelosContentType,
  MelosDeviceType,
} from '@/services/api.service';
import MelosSquareButton from '@/components/MelosSquareButton.vue';
import fo from '@/assets/1o.svg';
import vynil from '@/assets/vynil.svg';
import askarImage from '@/assets/askar.png';
import transmitterImage from '@/assets/transmitter.png';
import MelosButtonSet from '@/components/MelosButtonSet.vue';

@Component({
  components: {
    MelosSquareButton,
    MelosButtonSet,
  },
})
export default class MelosDevices extends Vue {
  private collectionUri: string = '/home/collection';
  private loading: boolean = false;
  private loadingPercentage: number = 0;

  private async mounted() {
    if (this.devices.length === 0) {
      await this.fetchContent();
    }
  }

  private get devices(): MelosDevice[] {
    return this.$store.state.ownedDevices || [];
  }

  private async createNewDevice() {
    await this.$apiService.registerDevice({
      name: 'My new device',
      type: MelosDeviceType.STANDALONE,
    });
    return this.fetchContent();
  }

  private selectAll() {
    this.checkedItems = [];
    this.devices.forEach((device) => this.checkedItems.push(device._id || ''));
  }

  private get checkedItems(): string [] {
    return this.$store.state.checkedItems || [];
  }

  private set checkedItems(itemList: string[]) {
    this.$store.commit('setCheckedItems', itemList);
  }

  private onStateUpdate(state: boolean, id: string) {
    if (state) {
      this.checkedItems.push(id);
    } else {
      this.checkedItems.splice(this.checkedItems.indexOf(id), 1);
    }
  }

  private get optionLabels(): string [] {
    const labels = [];
    if (this.checkedItems.length < this.devices.length) {
      labels.push('DOUBLE');
    }
    if (this.checkedItems.length > 0) {
      labels.push('x');
    }
    if (this.checkedItems.length > 0) {
      labels.push('trash');
    }
    return labels;
  }

  private async removeAllSelectedItems() {
    const selectedDevices = this.devices.filter((deviceData) => {
      return this.checkedItems.includes(deviceData._id || '');
    });

    for (const device of selectedDevices) {
      await this.$apiService.removeDevice(device._id || '');
    }

    this.checkedItems = [];

    return this.fetchContent();
  }

  private onOptionClick(index: number) {
    const option: string = this.optionLabels[index] || '';
    switch (option) {
    case 'DOUBLE':
      this.selectAll();
      break;
    case 'x':
      this.checkedItems = [];
      break;
    case 'trash':
      (this as any).$ons.notification.confirm('Are you sure you want to delete the selected items?')
      .then((response: number) => response === 1 ? this.removeAllSelectedItems() : undefined);
      break;
    }
  }

  private loggedIn(): boolean {
    return !!this.$sessionService.getSessionData() &&
    this.$sessionService.getSessionData().token !== '';
  }

  private get token(): string {
    return this.$store.state.session?.token || '';
  }

  private async fetchContent() {
    if (!this.loggedIn()) {
      return;
    }
    const ownedDevices = await this.$apiService.getDevices();
    this.$store.commit('setOwnedDevices', ownedDevices);
  }

  private getDeviceImage(device: any) {
    return device.type === MelosDeviceType.TRANSMITTER ? transmitterImage : askarImage;
  }

}
